import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import formatDate from '../../../../../../app/frontend/components/components/utils/formatDate';
import Price from '../../../../../../app/frontend/components/components/utils/numbers/Price';
import ResponsiveHeader from '../../../../shared/components/ResponsiveHeader';

const Completed = ({ offer }) => {
  const { t } = useTranslation();
  console.log('offer', offer);
  const { user_offer: userOffer, payments, extra_payments: extraPayments, products } = offer;
  if (!userOffer) return <div></div>;

  const Payments = useCallback(({ payments, extraPayments }) => (
    <React.Fragment>
      {payments.map((payment, idx) => (
        <Row key={idx} className='d-sm-flex'>
          <Col xs={12} md={6} className='mb-4-5'>
            <h3 className='mb-0'>
              <Price number={payment.user_payment_value} currency={payment.currency}></Price>
            </h3>
            {t('influencers.common.payment_amount')}
          </Col>
          <Col xs={12} md={6} className='mb-4-5'>
            <h3 className='mb-0'>
              {formatDate(userOffer.estimated_payment_date, { format: 'L' })}
            </h3>
            {t('influencers.common.estimated_payment_date')}
          </Col>
        </Row>
      ))}
      {
        extraPayments.map((payment, idx) => (
          <Row key={idx} className='d-sm-flex'>
            <Col xs={12} md={6} className='mb-4-5'>
              <h3 className='mb-0'>
                <Price number={payment.amount} currency={payment.currency}></Price>
              </h3>
              {t('influencers.common.extra_payment_amount')}
            </Col>
          </Row>
        ))
      }
      <div className='mb-4-5'>
        <h3 className='mb-0 text-break'>{userOffer.user.paypal_email}</h3>
        {t('influencers.common.current_paypal_email')}
      </div>
    </React.Fragment>
  ), [payments]);

  const Products = useCallback(({ products }) => (
    <React.Fragment>
      {products.map((product, idx) => (
        <div key={idx} className='mb-4-5'>
          <h3 className='mb-0'>{product.name}</h3>
          {t('influencers.common.reward')}
        </div>
      ))}
    </React.Fragment>
  ), [products]);

  return (
    <React.Fragment>
      <ResponsiveHeader xs="h3" sm="h4">
        {t('influencers.pages.campaign.status.done')}
      </ResponsiveHeader>
      <div className='mb-5'>
        {t('influencers.pages.campaign.status.desc_done')}
      </div>
      <Row className='d-sm-flex'>
        <Col xs="12" md={6} className='mb-4-5'>
          <h3 className='mb-0'>{userOffer.likes}</h3>
          {t('influencers.common.likes')}
        </Col>
        <Col xs="12" md={6} className='mb-4-5'>
          <h3 className='mb-0'>{userOffer.comments}</h3>
          {t('influencers.common.comments')}
        </Col>
      </Row>
      {products.length > 0 && <Products products={products} />}
      {(payments.length > 0 || extraPayments.length > 0) && <Payments payments={payments} extraPayments={extraPayments} />}
    </React.Fragment>
  );
};

Completed.propTypes = {
  offer: PropTypes.object.isRequired
};

export default Completed;
